import script from "./ApiApplicationPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiApplicationPermissions.vue?vue&type=script&setup=true&lang=js"

import "./ApiApplicationPermissions.vue?vue&type=style&index=0&id=27fdf983&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fdf983"]])

export default __exports__